import React, { useContext, useState } from "react";
import { CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { OrderListingContext } from "../../listing/context/OrderListingContext";
import { mapToRejectOrderItem, RejectMultipleOrdersDialog } from "./RejectMultipleOrdersDialog";

export const RejectMultipleOrdersButton: React.VFC = () => {
    const { selectedItems } = useContext(OrderListingContext);

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const open = () => {
        setIsOpen(true);
    };

    const close = () => {
        setIsOpen(false);
    };

    const handleRemovingComplete = () => {
        close();
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdAdmin, SprintAccessRight.OrdReadWrite]}>
            <CommandBarButton text="Reject" icon="PageRemove" disabled={!selectedItems.length} onClick={open} />
            {isOpen && (
                <RejectMultipleOrdersDialog
                    key={String(isOpen)}
                    selectedItems={selectedItems.map((item) => mapToRejectOrderItem(item))}
                    onRejectingComplete={handleRemovingComplete}
                />
            )}
        </AuthorizationWrapper>
    );
};
